// extracted by mini-css-extract-plugin
export default {"position-dot":"position-dot--OMmPC","positionDot":"position-dot--OMmPC"};